import { defineMessages } from 'react-intl';

export default defineMessages({
  externalLinkAria: {
    id: 'shared.externalLink',
    defaultMessage: 'opens in new window',
    description: 'warning for user that link will open a new page.',
  },
});
